import React from 'react';
import { Box, Typography } from '@mui/material';

import { InfoTooltip } from '../../../components/core';

interface CardItemProps {
  size: 'large' | 'medium' | 'small';
  metric?: string;
  label: string;
  tooltip?: string;
}

export const CardItem: React.FC<CardItemProps> = ({ size, metric = '-', label, tooltip }) => {
  const metricVariant = (
    {
      large: 'huge',
      medium: 'xxl',
      small: 'xl',
    } as const
  )[size];

  const labelVariant = (
    {
      large: 'medium',
      medium: 'small',
      small: 'micro',
    } as const
  )[size];

  return (
    <Box sx={{ minHeight: '60px' }}>
      <Typography
        variant={metricVariant}
        fontWeight="semibold"
        sx={{
          wordBreak: 'break-word',
        }}
      >
        {metric}
      </Typography>
      <Typography
        variant={labelVariant}
        color="text.secondary"
        component="span"
        sx={{
          mt: 0.5,
          wordBreak: 'break-word',
          display: 'block',
        }}
      >
        {label}
        {tooltip ? (
          <InfoTooltip
            title={tooltip}
            placement="top"
            variant="popover"
            popoverMaxWidth={250}
            popoverTextAlign="left"
            fontSize={size === 'small' ? 12 : 14}
            iconTone="muted"
            iconSx={{ ml: 0.5, verticalAlign: 'middle' }}
            ariaLabel={`${label} details`}
          />
        ) : null}
      </Typography>
    </Box>
  );
};
